import { ExtrudeGeometry, Mesh, Scene, Shape, Vector2 } from 'three';
import { STLExporter } from 'three/examples/jsm/exporters/STLExporter.js';

import { Polygon2D } from '@paragon/geometry-library';

export interface MemberGeometryInfo {
  readonly polygon: Polygon2D;
  readonly thickness: number;
}

export const getMeshFromMember = (memberGeometryInfo: MemberGeometryInfo) => {
  const { polygon, thickness } = memberGeometryInfo;
  const vertices = polygon.vertices.map((point) => new Vector2(point.x, point.y));
  const memberShape = new Shape(vertices);
  const extrudeGeometry = new ExtrudeGeometry(memberShape, {
    depth: thickness,
    bevelEnabled: false,
  });
  return new Mesh(extrudeGeometry);
};

export const getSTLFromComponent = (memberGeometryInfos: readonly MemberGeometryInfo[]) => {
  const scene = new Scene();
  for (const memberGeometryInfo of memberGeometryInfos) {
    scene.add(getMeshFromMember(memberGeometryInfo));
  }
  return new STLExporter().parse(scene);
};
